import React from 'react'
import styled from 'styled-components'

import productPlaceholderImage from '../../../img/product-image-placeholder.png'

export interface ItemImageProps {
  className?: string
  image: {
    label?: string | null
    url?: string | null
  }
  variant?: 'default' | 'small'
  icon?: React.ReactNode
}

const ItemImage: React.FC<ItemImageProps> = ({ className, image, icon }) => {
  return (
    <div className={className}>
      {icon}
      <img alt={image.label || ''} src={image.url || productPlaceholderImage} />
    </div>
  )
}

const StyledItemImage = styled(ItemImage)`
  position: relative;
  box-sizing: border-box;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: ${({ variant }) => (variant === 'small' ? '75px' : '125px')};
  overflow: hidden;
  ${({ variant }) => variant === 'small' && 'margin-left: 15px;'}
  margin-right: 10px;
  img {
    background: ${({ theme }) => theme.colors.coolGray.cool150};
    border-radius: 4px;
    object-fit: contain;
    width: 100%;
  }
`

export default StyledItemImage
